const checkSessionCookieURL = `${process.env.REACT_APP_API_URL}/api/public/check-cookie`;
const userInfoURL = `${process.env.REACT_APP_API_URL}/api/public/headers`;
const loginURL = `${process.env.REACT_APP_API_URL}/sp/login`;

/**
 * GET request to authenticate and fetch user information.
 * TEMPORARY FOR DEMO/TESTING
 */

// check session every so often (15 min), or after api calls, or when page is loaded

// default page, not authenticated -> stay at default page
// default page, authenticated -> go to dashboard
// random page, not authenticated -> redirect default page, , redirect to backend shib login, authenticate, then redirect back to random page
// random page, authenticated -> do nothing

export const login = async (target) => {
    let finalLoginURL = loginURL;
    if (target != null) {
        finalLoginURL += "?target=" + encodeURIComponent(target);
    }

    window.location.replace(finalLoginURL);
}

export const checkCookie = async () => {
    try {
        const response = await fetch(
            checkSessionCookieURL,
            {
                method: "GET",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        if (!response.ok) {
            // Non 200 responses
            return null;
        }
        return response;
    } catch (error) {
        console.error("Error checking cookie:", error);
        return null;
    }
}

export const checkSession = async (currPage, navigate) => {
    // if on default page and checking session, currPage = null, UNLESS in query param: target
    const response = await checkCookie();
    try {
        if (response != null) {

            // if session is still active and currPage is null (default page), auto log them in and continue to dashboard
            // if session is still active and currPage is a random page, do nothing - already logged in
            if (currPage === "/") {
                login(null);
            }
            const responseBody = await response.json();
            if (responseBody && responseBody.length > 0) {
                return responseBody.map(role => role.roleName);
              } else {
                return ["USER"];
              }
        } else {
            console.log('User is not authenticated or an error occurred.');

            // if session is NOT active and currPage is null, do nothing - user needs to click login button
            if (currPage === "/") {
                return;
            }

            // if session is NOT active and currPage is a random page, 
            // make them go to default page - after clicking login, should be redirected back to the random page they were originally on

            // /member/dashboard
            let redirect = "/?target=" + encodeURIComponent(currPage);
            navigate(redirect);

            // Perform actions for unauthenticated users or handle errors here
        }
    } catch (error) {
        console.error('Error during cookie check:', error);
        login(null);
    }
};


export const getHeaders = async () => {
    try {
        const response = await fetch(
            userInfoURL,
            {
                method: "GET",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        if (!response.ok) {
            // Non 200 responses
            return null;
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error checking cookie:", error);
        return null;
    }
}
